import { registerEventHandler } from 'reffects';
import { state } from 'reffects-store';
import { queryParams } from 'reffects-batteries';

export default function registerEvents() {
  registerEventHandler(
    'RETRIEVE_TARGET_PATH',
    function retrieveTargetPath({ queryParams: { _target_path: targetPath } }) {
      return {
        ...state.set({
          targetPath,
        }),
      };
    },
    [queryParams.get(['_target_path'])]
  );

  registerEventHandler('SHOW_LOGIN_FORM', function showLoginForm() {
    return {
      ...state.set({
        isForgotPasswordVisible: false,
        disableForgotPasswordForm: false,
      }),
    };
  });

  registerEventHandler(
    'SHOW_FORGOT_PASSWORD_FORM',
    function showForgotPasswordForm() {
      return {
        ...state.set({
          isForgotPasswordVisible: true,
        }),
      };
    }
  );
}
